__turbopack_context__.v({
  "agent": "website-hero-demo-module__T7DZ-G__agent",
  "agentBubble": "website-hero-demo-module__T7DZ-G__agentBubble",
  "agentIdentity": "website-hero-demo-module__T7DZ-G__agentIdentity",
  "back": "website-hero-demo-module__T7DZ-G__back",
  "callout": "website-hero-demo-module__T7DZ-G__callout",
  "camera": "website-hero-demo-module__T7DZ-G__camera",
  "cardBody": "website-hero-demo-module__T7DZ-G__cardBody",
  "cardHeading": "website-hero-demo-module__T7DZ-G__cardHeading",
  "compactExplanation": "website-hero-demo-module__T7DZ-G__compactExplanation",
  "composer": "website-hero-demo-module__T7DZ-G__composer",
  "connector": "website-hero-demo-module__T7DZ-G__connector",
  "conversation": "website-hero-demo-module__T7DZ-G__conversation",
  "conversationTitle": "website-hero-demo-module__T7DZ-G__conversationTitle",
  "courseAction": "website-hero-demo-module__T7DZ-G__courseAction",
  "cursor": "website-hero-demo-module__T7DZ-G__cursor",
  "dateList": "website-hero-demo-module__T7DZ-G__dateList",
  "demoDates": "website-hero-demo-module__T7DZ-G__demoDates",
  "device": "website-hero-demo-module__T7DZ-G__device",
  "engraving": "website-hero-demo-module__T7DZ-G__engraving",
  "escalateControl": "website-hero-demo-module__T7DZ-G__escalateControl",
  "escalation": "website-hero-demo-module__T7DZ-G__escalation",
  "eventDetail": "website-hero-demo-module__T7DZ-G__eventDetail",
  "eventPopout": "website-hero-demo-module__T7DZ-G__eventPopout",
  "eventSentiment": "website-hero-demo-module__T7DZ-G__eventSentiment",
  "halo": "website-hero-demo-module__T7DZ-G__halo",
  "header": "website-hero-demo-module__T7DZ-G__header",
  "headerName": "website-hero-demo-module__T7DZ-G__headerName",
  "inputText": "website-hero-demo-module__T7DZ-G__inputText",
  "instructionInput": "website-hero-demo-module__T7DZ-G__instructionInput",
  "labelEnter": "website-hero-demo-module__T7DZ-G__labelEnter",
  "liftExplanation": "website-hero-demo-module__T7DZ-G__liftExplanation",
  "liftedInstruction": "website-hero-demo-module__T7DZ-G__liftedInstruction",
  "liveCard": "website-hero-demo-module__T7DZ-G__liveCard",
  "messageAvatar": "website-hero-demo-module__T7DZ-G__messageAvatar",
  "messageFeedback": "website-hero-demo-module__T7DZ-G__messageFeedback",
  "messages": "website-hero-demo-module__T7DZ-G__messages",
  "meta": "website-hero-demo-module__T7DZ-G__meta",
  "mode": "website-hero-demo-module__T7DZ-G__mode",
  "note": "website-hero-demo-module__T7DZ-G__note",
  "organisationLogo": "website-hero-demo-module__T7DZ-G__organisationLogo",
  "otpSuggestion": "website-hero-demo-module__T7DZ-G__otpSuggestion",
  "perspectiveLabel": "website-hero-demo-module__T7DZ-G__perspectiveLabel",
  "playback": "website-hero-demo-module__T7DZ-G__playback",
  "resolveControl": "website-hero-demo-module__T7DZ-G__resolveControl",
  "root": "website-hero-demo-module__T7DZ-G__root",
  "row": "website-hero-demo-module__T7DZ-G__row",
  "screen": "website-hero-demo-module__T7DZ-G__screen",
  "sendCircle": "website-hero-demo-module__T7DZ-G__sendCircle",
  "sentiment": "website-hero-demo-module__T7DZ-G__sentiment",
  "sidebar": "website-hero-demo-module__T7DZ-G__sidebar",
  "slot": "website-hero-demo-module__T7DZ-G__slot",
  "stage": "website-hero-demo-module__T7DZ-G__stage",
  "status": "website-hero-demo-module__T7DZ-G__status",
  "thinking": "website-hero-demo-module__T7DZ-G__thinking",
  "thought": "website-hero-demo-module__T7DZ-G__thought",
  "toolbar": "website-hero-demo-module__T7DZ-G__toolbar",
  "touchDot": "website-hero-demo-module__T7DZ-G__touchDot",
  "user": "website-hero-demo-module__T7DZ-G__user",
  "visitorAvatar": "website-hero-demo-module__T7DZ-G__visitorAvatar",
  "workspace": "website-hero-demo-module__T7DZ-G__workspace",
});
